var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69737 8.25V6.75H10.1053C10.2731 6.75 10.6184 6.95984 10.6184 7.5C10.6184 8.04016 10.2731 8.25 10.1053 8.25H7.69737Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69737 11.25V9.75H10.7368C10.9046 9.75 11.25 9.95984 11.25 10.5C11.25 11.0402 10.9046 11.25 10.7368 11.25H7.69737Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM8.52632 4.25C8.1121 4.25 7.77632 4.58579 7.77632 5V5.25H6C5.58579 5.25 5.25 5.58579 5.25 6C5.25 6.41421 5.58579 6.75 6 6.75H6.19737V11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H7.77632V13C7.77632 13.4142 8.1121 13.75 8.52632 13.75C8.94053 13.75 9.27632 13.4142 9.27632 13V12.75H10.7368C11.9643 12.75 12.75 11.6167 12.75 10.5C12.75 9.77478 12.4186 9.04255 11.8501 8.61829C12.0242 8.27537 12.1184 7.88669 12.1184 7.5C12.1184 6.3833 11.3327 5.25 10.1053 5.25H9.27632V5C9.27632 4.58579 8.94053 4.25 8.52632 4.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4C16.25 3.58579 16.5858 3.25 17 3.25C19.6234 3.25 21.75 5.37665 21.75 8V11.5C21.75 11.9142 21.4142 12.25 21 12.25C20.5858 12.25 20.25 11.9142 20.25 11.5V8C20.25 6.20507 18.7949 4.75 17 4.75C16.5858 4.75 16.25 4.41421 16.25 4Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 17C3.25 16.5858 3.58579 16.25 4 16.25C4.41421 16.25 4.75 16.5858 4.75 17C4.75 18.7949 6.20507 20.25 8 20.25H11.5C11.9142 20.25 12.25 20.5858 12.25 21C12.25 21.4142 11.9142 21.75 11.5 21.75H8C5.37665 21.75 3.25 19.6234 3.25 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalCurrency);
export default __webpack_public_path__ + "static/media/digital-currency.d580b927eeac5c0979540e7da42da80e.svg";
export { ForwardRef as ReactComponent };